import { IReport } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { ReportWorkItem } from 'src/app/business/swodoc/report-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class ReportCommandHandler extends EntityCommandHandler<IReport> {
  protected workItem: IWorkItem<IReport>;

  constructor(matchWorkItem: ReportWorkItem) {
    super();
    this.workItem = matchWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'ReportDto';
  }
}
